// Dependencies
import { FC } from "react";

interface CategoryIconProps {
  src: string;
  className?: string;
}

const CategoryIcon: FC<CategoryIconProps> = ({ src, className }) => {
  const imgSrc = src || "./category40x40/other.png";
  return <img className={className} src={imgSrc} alt="category icon" />;
};

export default CategoryIcon;
